export default {
  flowName: null,
  e2eFlow: null,
  flowState: null,
  flowCompanyIcon: null,
  flowTransitions: [],
  flowViewContent: [],
  flowViewOptions: {},
  flowError: null,
  flowCompany: '',
  flowCompanyColor: null
}
